import React, { useState } from "react";
import { Modal } from "@mui/material";
import { ButtonWrapper } from "../../../../shared/components/CancelModal/Styled";
import CustomButton from "../../../../shared/components/TitleRow/CustomButton";
import {
    ModalWrapper,
    StyledBackdrop,
    TitleText,
    TitleWrapper,
} from "../../../../shared/components/FailModal/Styled";
import DropdownMenu from "../../../../shared/components/DropdownMenu.tsx";
import { CustomerExportSortTypes } from "../../../../configs/sortTypes";

interface ExportModalProps {
    open: boolean;
    handleClose: Function;
    handleConfirm: Function;
}

export const ExportModal = ({
    open,
    handleClose,
    handleConfirm,
}: ExportModalProps) => {
    const [isOpen, setIsOpen] = useState(open);
    const [displayText, setDisplayText] = useState("Vui lòng chọn tháng");
    const [selectedMonth, setSelectedMonth] = useState<number | undefined>();

    const handleOnClickMonth = ({
        text,
        value,
    }: {
        text: string;
        value?: number;
    }) => {
        setDisplayText(text);
        setSelectedMonth(value);
    };

    const handleCloseWithAnimation = () => {
        setIsOpen(false);
        setTimeout(handleClose, 200);
    };

    const handleConfirmWithAnimation = () => {
        setIsOpen(false);
        setTimeout(() => handleConfirm(selectedMonth), 200);
    };

    return (
        <Modal
            open={isOpen}
            onClose={handleCloseWithAnimation}
            closeAfterTransition
            BackdropComponent={StyledBackdrop}
            BackdropProps={{
                timeout: 500,
                onClick: (e) => e.stopPropagation(),
            }}
        >
            <ModalWrapper isOpen={open}>
                <TitleWrapper>
                    <TitleText>Tuỳ chỉnh xuất file khách hàng</TitleText>
                </TitleWrapper>

                <div
                    style={{
                        marginTop: "20px",
                        height: "36px",
                        fontFamily: "Noto Sans",
                    }}
                >
                    <DropdownMenu
                        menuList={CustomerExportSortTypes}
                        menuText={displayText}
                        handleOnclickItem={handleOnClickMonth}
                    />
                </div>

                <ButtonWrapper>
                    <CustomButton
                        title="Huỷ"
                        onClick={handleCloseWithAnimation}
                        style={{
                            paddingTop: 8,
                            paddingBottom: 8,
                            display: "flex",
                            justifyContent: "center",
                            width: "60%",
                            minWidth: "120px",
                        }}
                    />
                    <CustomButton
                        title={"Xuất"}
                        variant="contained"
                        onClick={handleConfirmWithAnimation}
                        style={{
                            paddingTop: 8,
                            paddingBottom: 8,
                            display: "flex",
                            justifyContent: "center",
                            width: "60%",
                            minWidth: "120px",
                        }}
                    />
                </ButtonWrapper>
            </ModalWrapper>
        </Modal>
    );
};
